/* NECES Product Cards — delegated add-to-quote + card enhancement
   Runs on all pages (no template gate). Stepper + button rendered by Liquid;
   click handling via document-level delegation — zero re-wiring needed. */
(function() {
  'use strict';

  /* ==================================================================
     DELEGATED CLICK HANDLERS — one listener, all surfaces
     ================================================================== */
  document.addEventListener('click', function(e) {
    // Qty minus
    var minus = e.target.closest('[data-qty-minus]');
    if (minus) {
      e.preventDefault();
      e.stopPropagation();
      var input = minus.closest('.nc-card-qty').querySelector('[data-qty-input]');
      var v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
      return;
    }

    // Qty plus
    var plus = e.target.closest('[data-qty-plus]');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      var input = plus.closest('.nc-card-qty').querySelector('[data-qty-input]');
      var v = parseInt(input.value) || 1;
      input.value = v + 1;
      return;
    }

    // Add to Quote (Liquid-rendered button)
    var addBtn = e.target.closest('[data-nc-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = addBtn.getAttribute('data-variant-id');
      var actions = addBtn.closest('.nc-card-actions');
      var qtyInput = actions ? actions.querySelector('[data-qty-input]') : null;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      ajaxAdd(variantId, qty, addBtn);
      return;
    }
  });

  // Prevent card-link navigation when clicking qty input
  document.addEventListener('click', function(e) {
    if (e.target.hasAttribute && e.target.hasAttribute('data-qty-input')) {
      e.stopPropagation();
    }
  });

  /* ==================================================================
     PDP FORM INTERCEPT — capture-phase click handler
     Only active when .nc-pdp-quote is present (quote-only PDP).
     Routes native form submit through ajaxAdd.
     ================================================================== */
  document.addEventListener('click', function(e) {
    if (!document.querySelector('.nc-pdp-quote')) return;
    var btn = e.target.closest('product-form-component button[type="submit"], .buy-buttons-block button[type="submit"]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var form = btn.closest('form');
    if (!form) return;

    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!idInput) return;

    ajaxAdd(idInput.value, qtyInput ? parseInt(qtyInput.value) || 1 : 1, btn);
  }, true);

  // Block native form submit on quote-only PDPs
  document.addEventListener('submit', function(e) {
    if (!document.querySelector('.nc-pdp-quote')) return;
    if (e.target.closest('product-form-component, .buy-buttons-block')) {
      e.preventDefault();
    }
  });

  /* ==================================================================
     PDP BUTTON RELABEL — "Add to Cart" → "Add to Quote"
     Runs on init + mutations to catch async renders and variant changes.
     ================================================================== */
  function relabelPdpButton() {
    if (!document.querySelector('.nc-pdp-quote')) return;
    document.querySelectorAll('product-form-component button[type="submit"], .buy-buttons-block button[type="submit"]').forEach(function(btn) {
      if (!btn.disabled && btn.textContent.trim() !== 'Add to Quote') {
        btn.textContent = 'Add to Quote';
      }
    });
  }

  /* ==================================================================
     AJAX ADD TO CART
     ================================================================== */
  function ajaxAdd(variantId, qty, btn) {
    var origText = btn.textContent;
    btn.textContent = 'Adding\u2026';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.textContent = 'Added to Quote \u2713';
      btn.style.background = '#1a6847';
      updateBadge();
      // On the cart page, reload so the items list shows the new line
      if (window.location.pathname.indexOf('/cart') === 0) {
        setTimeout(function() { window.location.reload(); }, 700);
        return;
      }
      setTimeout(function() {
        btn.textContent = origText;
        btn.style.background = '';
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      btn.textContent = 'Error \u2014 try again';
      setTimeout(function() {
        btn.textContent = origText;
        btn.style.background = '';
        btn.disabled = false;
      }, 1500);
    });
  }

  /* ==================================================================
     BADGE UPDATE
     ================================================================== */
  function updateBadge() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var badge = document.querySelector('.nc-hdr__cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          if (cart.item_count > 0) badge.removeAttribute('hidden');
          else badge.setAttribute('hidden', '');
        }
      });
  }

  /* ==================================================================
     CARD ENHANCEMENT — vendor, SKU, price badge, delivery, finance
     Runs per card on first encounter. Button wiring is NOT here
     (delegated handlers above cover all cards automatically).
     ================================================================== */
  function enhanceCards() {
    var cards = document.querySelectorAll('.product-card, product-card');
    cards.forEach(function(card) {
      if (card.dataset.ncEnhanced) return;
      card.dataset.ncEnhanced = 'true';

      var linkEl = card.querySelector('a[href*="/products/"]');
      var productUrl = linkEl ? linkEl.getAttribute('href') : '';
      var contentArea = card.querySelector('.product-card__content, .card__content');
      if (!contentArea || !productUrl) return;

      // Fix title height — force 3-line clamp for grid alignment
      // NOTE: never match 'a.contents' — that class is the GALLERY wrapper in this
      // theme and clamping it crushes the product image to 58.8px.
      var titleLink = contentArea.querySelector('a[ref="productTitleLink"]');
      if (titleLink && titleLink.querySelector('slideshow-component, .card-gallery, img, svg')) titleLink = null;
      if (titleLink) {
        titleLink.style.height = '4.2em';
        titleLink.style.overflow = 'hidden';
        titleLink.style.display = 'block';
        titleLink.style.lineHeight = '1.3';
        titleLink.style.fontSize = '14px';
      }

      // Hide theme's native price immediately
      var nativePrice = contentArea.querySelector('[data-block-type="price"], .price-block, .price');
      if (nativePrice) nativePrice.style.display = 'none';

      // Fetch product data for vendor, SKU, price badge
      var jsonUrl = productUrl.split('?')[0] + '.json';
      fetch(jsonUrl).then(function(r) { return r.json(); }).then(function(data) {
        var p = data.product;
        if (!p) return;

        var vendor = p.vendor || '';
        var sku = (p.variants && p.variants[0]) ? p.variants[0].sku || '' : '';
        var price = (p.variants && p.variants[0]) ? parseFloat(p.variants[0].price) || 0 : 0;
        var quoteAttr = card.getAttribute('data-quote-only');
        var isQuote = (quoteAttr === 'true') || (price === 0);

        // === VENDOR (above title) ===
        if (vendor) {
          var titleBlock = contentArea.querySelector('[class*="product-title"], .product-card__title, .card__heading');
          if (titleBlock && !(titleBlock.previousElementSibling && titleBlock.previousElementSibling.classList.contains('nc-card-vendor'))) {
            var vendorEl = document.createElement('div');
            vendorEl.className = 'nc-card-vendor';
            vendorEl.textContent = vendor;
            titleBlock.parentNode.insertBefore(vendorEl, titleBlock);
          }
        }

        // === PRICE or QUOTE BADGE ===
        // 17 Jul 2026 — NC_SHOW_CARD_POA set FALSE: quote system live, the
        // "Price on Application" card badge is redundant (Add to Quote says it).
        // Kept with its CSS for possible reintroduction — flip to true to restore.
        // Non-quote products still show their real price block regardless.
        var NC_SHOW_CARD_POA = false;
        if (!isQuote || NC_SHOW_CARD_POA) {
          var priceBlock = document.createElement('div');
          if (isQuote) {
            priceBlock.className = 'nc-card-quote-block';
            priceBlock.innerHTML = '<span class="nc-card-quote">Price on Application</span>';
          } else {
            priceBlock.className = 'nc-card-price-block';
            var formatted = '$' + price.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            priceBlock.innerHTML = '<span class="nc-card-price-main">' + formatted + '</span><span class="nc-card-price-gst">inc GST</span>';
          }
          contentArea.appendChild(priceBlock);
        }

        // === SKU ROW ===
        if (sku) {
          var skuRow = document.createElement('div');
          skuRow.className = 'nc-card-sku-row';
          skuRow.innerHTML = '<strong>Code:</strong> ' + sku;
          contentArea.appendChild(skuRow);
        }

        // === DELIVERY STATUS (non-quote only) ===
        if (!isQuote) {
          var delivEl = document.createElement('div');
          delivEl.className = 'nc-card-delivery';
          delivEl.textContent = 'Available \u2014 Delivery to NE Victoria';
          contentArea.appendChild(delivEl);
        }

        // === FINANCE HINT (non-quote, >= $1000) ===
        if (!isQuote && price >= 1000) {
          var finEl = document.createElement('div');
          finEl.className = 'nc-card-finance';
          finEl.textContent = 'SilverChef finance available';
          contentArea.appendChild(finEl);
        }

        // === VIEW PRODUCT link (non-quote products only) ===
        // Quote products use the Liquid-rendered stepper (.nc-card-actions)
        if (!isQuote) {
          var viewBtn = document.createElement('a');
          viewBtn.href = productUrl;
          viewBtn.className = 'nc-card-action nc-card-action--view';
          viewBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>View Product';
          contentArea.appendChild(viewBtn);
        }
      }).catch(function() {});
    });
  }

  /* ==================================================================
     INIT
     ================================================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      enhanceCards();
      relabelPdpButton();
    });
  } else {
    enhanceCards();
    relabelPdpButton();
  }

  // MutationObserver — enhances content on dynamically loaded cards
  // (pagination, filtering, recommendations). NOT for button wiring —
  // delegated handlers above cover that automatically.
  // Also relabels PDP button after async renders / variant changes.
  var enhanceTimer;
  var observer = new MutationObserver(function(mutations) {
    var hasNew = mutations.some(function(m) { return m.addedNodes.length > 0; });
    if (hasNew) {
      clearTimeout(enhanceTimer);
      enhanceTimer = setTimeout(function() {
        enhanceCards();
        relabelPdpButton();
      }, 200);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
